import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LoadingSpinner = ({
  message = "Loading data...",
  size = "large",
  fullScreen = true,
  sx = {},
}) => {
  const theme = useTheme();

  const getSpinnerSize = () => {
    switch (size) {
      case "small":
        return 24;
      case "medium":
        return 40;
      case "large":
        return 60;
      default:
        return 60;
    }
  };

  const getMessageSize = () => {
    switch (size) {
      case "small":
        return "body2";
      case "medium":
        return "body1";
      case "large":
        return "h6";
      default:
        return "h6";
    }
  };

  const containerStyles = fullScreen
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        zIndex: theme.zIndex.modal + 1,
      }
    : {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px",
        width: "100%",
      };

  return (
    <Box sx={{ ...containerStyles, ...sx }}>
      <CircularProgress
        size={getSpinnerSize()}
        thickness={4}
        sx={{
          color: theme.palette.primary.dark,
          mb: 2,
        }}
      />
      {message && (
        <Typography
          variant={getMessageSize()}
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "center",
            maxWidth: "300px",
          }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
